import { Circle, List, MagnifyingGlass, Moon, Sun, X } from "@phosphor-icons/react";
import { useState } from "react";
import type { Category } from "../types";

const categories: Category[] = ["Dzisiaj", "AI", "Technologia", "Polska", "Świat"];

interface HeaderProps {
  active: Category;
  onCategory: (category: Category) => void;
  onSearch: () => void;
  onEditions: () => void;
  onComic: () => void;
  comicAvailable: boolean;
  theme: "light" | "dark";
  onToggleTheme: () => void;
}

export function Header({
  active,
  onCategory,
  onSearch,
  onEditions,
  onComic,
  comicAvailable,
  theme,
  onToggleTheme,
}: HeaderProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  const date = new Intl.DateTimeFormat("pl-PL", { weekday: "long", day: "numeric", month: "long" }).format(new Date());
  const choose = (category: Category) => {
    onCategory(category);
    setMenuOpen(false);
  };

  return <header className="site-header">
    <a className="brand" href="#top" aria-label="NEWS.PAWEŁTAŃSKI — strona główna">
      <Circle weight="fill" aria-hidden="true" />
      <span><b>NEWS.</b><strong>PAWEŁTAŃSKI</strong></span>
    </a>

    <nav className="desktop-nav" aria-label="Główna nawigacja">
      {categories.map(category => <button key={category} className={active === category ? "active" : ""} onClick={() => choose(category)}>{category}</button>)}
      <button onClick={onComic} disabled={!comicAvailable}>KOMIX</button>
    </nav>

    <div className="header-actions">
      <button type="button" aria-label="Szukaj" onClick={onSearch}><MagnifyingGlass weight="bold" /></button>
      <button type="button" aria-label={theme === "light" ? "Włącz tryb ciemny" : "Włącz tryb jasny"} onClick={onToggleTheme}>
        {theme === "light" ? <Moon weight="bold" /> : <Sun weight="bold" />}
      </button>
      <button className="header-date" type="button" onClick={onEditions}>{date}</button>
      <button className="menu-button" type="button" aria-label={menuOpen ? "Zamknij menu" : "Otwórz menu"} aria-expanded={menuOpen} onClick={() => setMenuOpen(value => !value)}>
        {menuOpen ? <X weight="bold" /> : <List weight="bold" />}
      </button>
    </div>

    {menuOpen && <nav className="mobile-menu" aria-label="Menu mobilne">
      {categories.map(category => <button key={category} className={active === category ? "active" : ""} onClick={() => choose(category)}>{category}</button>)}
      <button onClick={() => { onComic(); setMenuOpen(false); }} disabled={!comicAvailable}>KOMIX</button>
      <button onClick={() => { onEditions(); setMenuOpen(false); }}>Archiwum wydań</button>
    </nav>}
  </header>;
}
